import { Instagram, Youtube, Linkedin, Music2 } from "lucide-react";

const XIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const socials = [
  { id: "instagram", label: "Instagram", icon: Instagram, href: "#" },
  { id: "x", label: "X", icon: XIcon, href: "#" },
  { id: "youtube", label: "YouTube", icon: Youtube, href: "#" },
  { id: "tiktok", label: "TikTok", icon: Music2, href: "#" },
  { id: "linkedin", label: "LinkedIn", icon: Linkedin, href: "#" },
];

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-black/10 px-6 md:px-12 py-16">
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
      <div>
        <p className="font-heading font-black tracking-tight text-zinc-950 text-lg">
          HARRIS<span className="text-[#00E5FF]"> HOLT</span>
        </p>
        <p className="mt-3 text-base text-zinc-500 max-w-sm">
          Smarter, more efficient digital and mission innovations for government
          and commercial customers.
        </p>
      </div>
      <div className="flex items-center gap-4">
        {socials.map((s) => (
          <a
            key={s.id}
            href={s.href}
            data-testid={`social-${s.id}`}
            aria-label={s.label}
            className="w-11 h-11 flex items-center justify-center border border-black/10 text-zinc-500 hover:text-[#0891B2] hover:border-[#0891B2]/50 transition-colors"
          >
            <s.icon size={18} />
          </a>
        ))}
      </div>
    </div>
    <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-black/10 flex flex-col sm:flex-row justify-between gap-4">
      <p className="font-mono text-sm text-zinc-600">© 2026 Harris Holt Consulting. All rights reserved.</p>
      <p className="font-mono text-sm text-zinc-600">Integrity. Innovation. Mission.</p>
    </div>
  </footer>
);
